import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip,{staticClass:"mr-2 mt-1 chip",attrs:{"disabled":_vm.searchLoad,"close":"","color":"#C1B7FE","label":"","text-color":"white"},on:{"click:close":function($event){return _vm.$emit('delete', _vm.model, _vm.id)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }